import MaskedInput from 'react-text-mask'
import React from 'react'

import { masks } from '../../../utils'

const CpfInput = ({ inputRef, ...rest }) => (
  <MaskedInput
    ref={ref => {
      inputRef(ref ? ref.inputElement : null)
    }}
    mask={masks.cpfMask}
    showMask
    guide={false}
    {...rest}
  />
)

export default CpfInput
